<template>
  <v-dialog v-model="dialog" persistent max-width="1100px" height="80%" ref="winPresent">
    <v-card>
      <v-card-title>
        <div class="d-flex flex-column card-title">
          <h2
            class="bis"
          >Ajouter {{showProducts? " des produits " : " des dossiers " }}de la matrice{{getWinText()}}</h2>
        </div>
      </v-card-title>
      <v-card-text grid-list-xl :style="stylecontainer">
        <div ref="mycontainer" class="d-flex flex-column" style="height:100%;">
          <div class="flex-grow-0">
            <v-layout class="mx-2 mb-4">
              <v-flex class="d-flex flex-row btn-switch">
                <p class="label-switch">Voir les familles2</p>
                <v-switch
                  v-model="showProducts"
                  :name="$Utils.randomstring('showProducts')"
                  color="#4e4e4e"
                  :inset="true"
                  :light="true"
                  label="Voir les produits"
                  class="mt-0 ml-4 mr-2"
                  :hide-details="true"
                ></v-switch>
              </v-flex>
            </v-layout>
            <catalog-search
              class="search mt-4"
              v-if="showProducts"
              @searchGo="searchGo"
              :catalog="0"
            ></catalog-search>
          </div>
          <div class="flex-grow-1 overflow-auto">
            <card-tree
              v-if="!showProducts"
              :ca_id="0"
              :colProblems="false"
              :colCheckbox="true"
              :colEdit="false"
              :canSelectLine="false"
              :path="'/catalogs/edit/'+ca_id"
              ref="addproductcardtree"
              @treeloaded="treeLoaded"
              :nodeSelected="nodeSelected"
              @majTabselectedNodeToAdd="majTabselectedNodeToAdd"
            ></card-tree>
            <m-card-products
              ref="cardProducts"
              v-if="showProducts"
              :colCheckbox="true"
              @addproduct="addproduct"
              @loaded="productsLoaded"
            ></m-card-products>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="primary2--text" color text @click="cancelWin()">Annuler</v-btn>
        <div>
          <v-btn
            color="primary2"
            depressed
            @click="saveWin()"
            :disabled="!(this.selectedProductsToAdd.length || this.selectedNodeToAdd.length)"
          >{{textInfoElementSelected}}</v-btn>
          <!-- <p class="info_element-selected">{{textInfoElementSelected}}</p> -->
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "catalogaddproduct",
  props: {},
  components: {},
  watch: {
    showProducts: function(val) {
      this.selectedProductsToAdd = [];
      this.selectedNodeToAdd = [];
      this.textInfoElementToAdd();
    }
  },
  data() {
    return {
      showProducts: true,
      fa_id: 0,
      arborescence: {},
      dialog: false,
      nodeSelected: {},
      name: "",
      ca_id: 0,
      stylecontainer: ``,
      selectedProductsToAdd: [],
      selectedNodeToAdd: [],
      textInfoElementSelected: "Ajouter des produits / familles"
    };
  },
  mounted() {},
  methods: {
    async open(fa_id, node, name, ca_id) {
      // console.log("fa_id, node, name, ca_id", fa_id, node, name, ca_id);
      this.selectedProductsToAdd = [];
      this.selectedNodeToAdd = [];
      this.fa_id = fa_id;
      this.nodeSelected = node;
      this.name = name;
      this.ca_id = ca_id;
      this.$router.push("/catalogs/edit/" + this.ca_id + "/addproducts");
      this.$nextTick(() => {
        if (this.showProducts) {
          this.$refs.cardProducts.loadProducts(0, { noSearchNoProduct: true });
        } else {
          this.$refs.addproductcardtree.getCatalog();
        }
      });
      this.dialog = true;
      this.setContainerStyle();
    },
    setContainerStyle() {
      let me = this;
      function go() {
        if (!me.$refs.mycontainer) return;
        let offset = 300;
        // if (me.showProducts) offset = 400;
        me.stylecontainer = `height: calc(100vh - ${offset}px); overflow:hidden;`;
      }
      go();
      window.setTimeout(go, 100);
      window.setTimeout(go, 1000);
    },
    treeLoaded(arborescence) {
      this.arborescence = arborescence;
      this.setContainerStyle();
    },
    productsLoaded() {
      //  console.log("load product");
      this.setContainerStyle();
    },
    getWinText() {
      let text = "";
      if (this.nodeSelected.level === 1) text = " à la famille " + this.name;
      if (this.nodeSelected.level === 2)
        text = " à la sous-famille " + this.name;
      if (this.nodeSelected.level === 3) text = " au segment " + this.name;
      return text;
    },
    async searchGo(
      searchProduct,
      searchFamily,
      searchSubFamily,
      searchStatus,
      searchPromo,
      searchMdd
    ) {
      let params = {
        searchProduct: searchProduct,
        searchFamily: searchFamily ? searchFamily.fa_id : searchFamily,
        searchSubFamily: searchSubFamily
          ? searchSubFamily.fa_id
          : searchSubFamily,
        searchStatus: searchStatus,
        searchPromo: searchPromo,
        searchMdd: searchMdd,
        noSearchNoProduct: true
      };
      if (this.$refs.cardProducts)
        this.$refs.cardProducts.loadProducts(0, params);
    },
    addproduct(pr_id, checked) {
      // console.log("checked3", checked);
      // console.log("pr_id", pr_id);
      this.selectedProductsToAdd = this.$_.without(
        this.selectedProductsToAdd,
        pr_id
      );
      if (checked) this.selectedProductsToAdd.push(pr_id);
      // console.log("this.selectedProductsToAdd", this.selectedProductsToAdd);
      this.textInfoElementToAdd();
    },
    cancelWin() {
      this.$router.push("/catalogs/edit/" + this.ca_id);
      this.dialog = false;
    },
    majTabselectedNodeToAdd(selectedNodeToAdd) {
      this.selectedNodeToAdd = selectedNodeToAdd;
      // console.log("this.selectedNodeToAdd", this.selectedNodeToAdd);
      this.textInfoElementToAdd();
    },
    textInfoElementToAdd() {
      if (this.showProducts) {
        this.textInfoElementSelected =
          "Ajouter " + this.selectedProductsToAdd.length + " produits";
      } else {
        let textLevel = "";
        if (this.nodeSelected.level === 1) textLevel = " sous-famille ";
        if (this.nodeSelected.level === 2) textLevel = " segement ";
        this.textInfoElementSelected =
          "Ajouter " + this.selectedNodeToAdd.length + textLevel;
      }
    },
    async saveWin() {
      // envoie des produits et de l'arborescence
      if (this.selectedProductsToAdd.length || this.selectedNodeToAdd.length) {
        // let response =
        await this.$axios.put(
          this.$config.server_url +
            "/api/1.0/catalogs/" +
            this.ca_id +
            "/addproducts/" +
            this.nodeSelected.id,
          {
            products: this.selectedProductsToAdd,
            arborescence: this.selectedNodeToAdd
          }
        );
      }
      this.$router.push("/catalogs/edit/" + this.ca_id);
      this.dialog = false;
      this.$emit("saved");
    },
    saved() {
      this.$emit("saved");
    }
  }
};
</script>

<style scoped lang="scss">
.info_element-selected {
  color: gray;
  font-size: 15px;
}
</style>